import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">OUTREACH</p>
          <h2 className="text-3xl md:text-4xl font-bold">VolunteerExperience</h2>
        </div>
        <div className="smsc-h mt-3 lgl:mt-6 w-full h-[500px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
            title="Web Development Instructor"
            subTitle="Freelancing Club UAF"
            result="Sep(2025)-Feb(2025)"
            des="Conducted a web development course for 70+ students covering foundational to advanced concepts. Organized hands-on workshops and interactive sessions to improve students’ coding skills."
          />

        </div>
      </div>
        
    </motion.div>
  );
};

export default Experience;
